import React from 'react';
import { Create } from 'react-admin';
import PositionRateSettingsForm from '../shared/position-rate-settings-form/PositionRateSettingsForm';
import { getTransform } from '../rateSettingsTransform';

const StatePositionRateSettingCreate = () => (
  <Create transform={getTransform(['state_id'], 'settings')}>
    <PositionRateSettingsForm settingsField="settings" />
  </Create>
);

export default StatePositionRateSettingCreate;
